import React, { FC } from "react";
import Check from "assets/icons/check.svg";
import { cn } from "helpers/style";
import styles from "./Radio.module.scss";

type Props = {
  name: string;
  value: string | number;
  disabled?: boolean;
  onChange?: (e: React.FormEvent) => void;
  onClick?: (e: React.MouseEventHandler<HTMLInputElement>) => void;
  checked?: boolean;
  label?: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

const Radio: FC<Props> = ({
  value,
  name,
  checked,
  label,
  disabled,
  onChange,
  onClick,
}: Props) => (
  <div className={styles.radio} key={value}>
    <label className={styles.radioLabel}>
      <input
        onChange={onChange}
        onClick={onClick}
        type="radio"
        name={name}
        disabled={disabled}
        checked={checked}
        value={value}
      />
      <div className={cn([styles.radioBox, checked && styles.radioBoxChecked])}>
        <Check />
      </div>
      <span className={styles.radioLabelText}>{label}</span>
    </label>
  </div>
);

export default Radio;
